import { useLocation } from 'react-router-dom'
import { isRouteEnabled } from '@/config/route-visibility'
import { NotFoundPage } from '@/pages/404'

interface RouteVisibilityGuardProps {
  children: React.ReactNode
}

/**
 * Single guard that checks the current pathname against route-visibility config.
 * When a path is disabled there, we show 404. Nav already hides those links
 * via the same config — so you only edit src/config/route-visibility.ts to
 * control what is hidden vs shown.
 */
export function RouteVisibilityGuard({ children }: RouteVisibilityGuardProps) {
  const location = useLocation()
  const pathname = location.pathname

  if (!isRouteEnabled(pathname)) {
    return <NotFoundPage />
  }

  return <>{children}</>
}
